/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import React, {FC} from 'react'
import {Link, NavLink} from 'react-router-dom'
import {useLayout} from '../../core'

const AsideDefault: FC = () => {
  const {config, classes} = useLayout()
  const {aside} = config

  return (
    <div
      id='kt_aside'
      className={clsx('aside')}
      data-kt-drawer='true'
      data-kt-drawer-name='aside'
      data-kt-drawer-activate='{default: true, lg: false}'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width="{default:'200px', '300px': '225px'}"
      data-kt-drawer-direction='start'
      data-kt-drawer-toggle='#kt_aside_toggle'
    >
      <div
        className='hover-scroll-overlay-y my-5 my-lg-5 w-100 ps-4 ps-lg-0 pe-4 me-1'
        id='kt_aside_menu_wrapper'
        data-kt-scroll='true'
        data-kt-scroll-activate='{default: false, lg: true}'
        data-kt-scroll-height='auto'
        data-kt-scroll-dependencies='#kt_header'
        data-kt-scroll-wrappers='#kt_aside'
        data-kt-scroll-offset='5px'
      >
        <div
          className='menu menu-column menu-active-bg menu-hover-bg menu-title-gray-700 fs-6 menu-rounded w-100'
          id='#kt_aside_menu'
          data-kt-menu='true'
        >
          <div className='menu-item'>
            <div className='menu-content pb-2'>
              <span className='menu-section text-muted text-uppercase fs-7 fw-bolder'>
                Vacancy by type
              </span>
            </div>
          </div>

          <div className='menu-item'>
            <NavLink to='/job' className='menu-link'>
              <span className='menu-title'>All Vacancies</span>
              <span className='menu-badge'>6,234</span>
            </NavLink>
          </div>

          <div className='menu-item'>
            <NavLink to='/jobs/filter/assigned' className='menu-link'>
              <span className='menu-title'>Assigned</span>
            </NavLink>
          </div>

          <div className='menu-item'>
            <NavLink to='/jobs/filter/interviewing' className='menu-link'>
              <span className='menu-title'>Interviewing</span>
            </NavLink>
          </div>

          <div className='menu-item'>
            <NavLink to='/jobs/filter/closed' className='menu-link'>
              <span className='menu-title'>Closed</span>
            </NavLink>
          </div>

          <div className='menu-item pt-5'>
            <div className='menu-content pb-2'>
              <span className='menu-section text-muted text-uppercase fs-7 fw-bolder'>
                Vacancy by skill
              </span>
            </div>
          </div>

          <div className='menu-item'>
            <Link to='/jobs/filter/react' className='menu-link'>
              <span className='menu-title'>React</span>
              <span className='menu-badge'>24</span>
            </Link>
          </div>

          <div className='menu-item'>
            <Link to='/jobs/filter/node' className='menu-link'>
              <span className='menu-title'>Node js</span>
              <span className='menu-badge'>120</span>
            </Link>
          </div>

          <div className='menu-item'>
            <Link to='/jobs/filter/swift' className='menu-link'>
              <span className='menu-title'>Swift</span>
              <span className='menu-badge'>10</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export {AsideDefault}
